import { Info, Lock } from 'generated/icons';
import classNames from 'classnames';
import React from 'react';
import AssetGlyph from './AssetGlyph';
import group from './assets/group.svg';
import calculator from './assets/calculator.svg';
import check from './assets/check.svg';

const assets = { group, calculator, check };
export type UpgradeIconName = keyof typeof assets | 'lock' | 'info';

interface Props {
  name: UpgradeIconName;
  className?: string;
  boxed?: boolean;
  tone?: 'primary' | 'success';
}

export default function UpgradeIcon({ name, className, boxed = false, tone = 'primary' }: Props) {
  const glyphClassName = classNames('shrink-0', !boxed && className);
  const glyph =
    name === 'lock' ? (
      <Lock className={glyphClassName} aria-hidden="true" />
    ) : name === 'info' ? (
      <Info className={glyphClassName} aria-hidden="true" />
    ) : (
      <AssetGlyph src={assets[name]} className={classNames('h-4 w-4', !boxed && className)} />
    );
  if (!boxed) return glyph;
  return (
    <span
      aria-hidden="true"
      className={classNames(
        'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg',
        tone === 'success' ? 'bg-alert-success/10 text-alert-success' : 'bg-control-primary/10 text-link',
        className,
      )}
    >
      {glyph}
    </span>
  );
}
